import * as React from "react";
const TrainingsView = React.lazy(() => import("src/views/TrainingsView/TrainingsViewContainer"));

export { TrainingsView };
